import { spawn, takeLatest, put } from 'redux-saga/effects';

// Actions
import { timerActions } from '../../../../application/actions/timer';


export function* fetchTimer() {
    yield put(timerActions.changeStatusTimer({ status: true }));
}

export function* watchFetchTimer() {
  yield takeLatest(timerActions.timerPassCoopeuch.type, fetchTimer);
}

export default function* rootSaga() {
  yield spawn(watchFetchTimer);
}
